(()=>{
if(customElements.get('okhomes-nearby'))return;
let dataPromise;
const cats=['supermarket','health','school','pharmacy','townhall','police','emergency'];
const el=(tag,cls,text)=>{const n=document.createElement(tag);if(cls)n.className=cls;if(text!==undefined)n.textContent=text;return n;};
const link=(text,url,cls)=>{const n=el('a',cls,text);n.href=url;n.target='_blank';n.rel='noopener noreferrer';return n;};
class Nearby extends HTMLElement{
connectedCallback(){
 if(this.connected)return;this.connected=true;
 const details=this.closest('details');
 const activate=()=>{if(this.started||details&&!details.open)return;this.started=true;this.init();};
 const hash=()=>{if(details&&location.hash==='#okhomes-nearby-services'){details.open=true;activate();this.alignToServices();}};
 this.onNearbyToggle=activate;this.onNearbyHash=hash;
 if(details){details.addEventListener('toggle',activate);window.addEventListener('hashchange',hash);window.addEventListener('pageshow',hash);hash();}
 activate();
}
disconnectedCallback(){
 this.closest('details')?.removeEventListener('toggle',this.onNearbyToggle);
 window.removeEventListener('hashchange',this.onNearbyHash);window.removeEventListener('pageshow',this.onNearbyHash);
 this.connected=false;
}
alignToServices(){
 if(location.hash!=='#okhomes-nearby-services')return;
 requestAnimationFrame(()=>requestAnimationFrame(()=>{
  const details=this.closest('details');if(!details||!details.open||location.hash!=='#okhomes-nearby-services')return;
  const header=document.querySelector('.section-header');
  const headerHeight=header?header.getBoundingClientRect().height:parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))||0;
  const viewportTop=window.visualViewport?.offsetTop||0;
  const top=window.scrollY+details.getBoundingClientRect().top-headerHeight-viewportTop-12;
  window.scrollTo({top:Math.max(0,top),behavior:'auto'});
 }));
}

async init(){
const status=this.querySelector('.okhomes-nearby__status'),content=this.querySelector('.okhomes-nearby__content');
let labels;
try{labels=JSON.parse(this.querySelector('[data-nearby-labels]').textContent);
if(!dataPromise){dataPromise=fetch(this.dataset.source,{credentials:'omit',signal:AbortSignal.timeout(10000)}).then(r=>{if(!r.ok)throw new Error('snapshot');return r.json();});}
const data=await dataPromise,key=data.properties?.[this.dataset.handle],zone=data.zones?.[key];
this.render(data,zone,labels,content);this.alignToServices();status.hidden=true;content.hidden=false;
}catch(e){status.textContent=labels?.unavailable||'Servicios pendientes de comprobar.';status.removeAttribute('aria-live');}
}
render(data,zone,t,content){
const locale=this.dataset.locale||'es',locality=this.dataset.locality||zone?.locality||'';
const list=el('ul','okhomes-nearby__rows');
if(zone){
content.append(el('p','okhomes-nearby__reference',t.reference+' '+zone.origin.name+'. '+t.distance_note));
}else{content.append(el('p','okhomes-nearby__reference',t.pending));}
for(const cat of cats){
const row=el('li','okhomes-nearby__row'),info=el('div'),metrics=el('div','okhomes-nearby__metrics');
info.append(el('span','okhomes-nearby__category',t[cat]));
const s=zone?.services.find(x=>x.cat===cat);
if(s&&Number.isFinite(s.km)&&s.km>=0){
info.append(el('span','okhomes-nearby__name',s.name||t[cat]));
const km=s.km<.1?'< 0,1':new Intl.NumberFormat(locale,{maximumFractionDigits:1,minimumFractionDigits:1}).format(s.km);
const minutes=Number.isFinite(s.minutes)?(s.minutes<1||s.km===0?'< 1':String(s.minutes))+' min':t.time_pending;
metrics.append(el('span','okhomes-nearby__distance',km+' km · '+minutes),el('span','okhomes-nearby__mode',s.mode==='driving'?t.driving:t.straight));
const url=new URL('https://www.google.com/maps/dir/');url.searchParams.set('api','1');url.searchParams.set('origin',zone.origin.lat+','+zone.origin.lon);url.searchParams.set('destination',s.lat+','+s.lon);url.searchParams.set('travelmode','driving');
metrics.append(link(t.route,url.href,'okhomes-nearby__route'));
}else{
info.append(el('span','okhomes-nearby__name',t.pending));
const url=new URL('https://www.google.com/maps/search/');url.searchParams.set('api','1');url.searchParams.set('query',t[cat]+' '+locality);
metrics.append(link(t.search,url.href,'okhomes-nearby__route'));
}
row.append(info,metrics);list.append(row);
}
content.append(list,el('p','okhomes-nearby__notes',t.approx+' '+t.access));this.renderTransport(data.transport?.[zone?.locality||locality],t,content,locality);
if(data.consulted){content.append(el('p','okhomes-nearby__source',t.date+' '+data.consulted.split('-').reverse().join('/')+'. '+t.snapshot));}
const source=el('p','okhomes-nearby__source','© ');source.append(link('OpenStreetMap','https://www.openstreetmap.org/copyright'),' · ',link('Geofabrik','https://download.geofabrik.de/europe/spain.html'),' · ',link('OSRM','https://project-osrm.org/'));content.append(source);
}
renderTransport(tr,t,content,locality){
const box=el('section','okhomes-nearby__transport');box.id='okhomes-nearby-transport';
box.append(el('h3','',t.transport_heading),el('p','',t.transport_intro),el('h4','',t.bus+(tr?.operator?' · '+tr.operator:'')));
const days={LMMcXV:t.days_weekdays,S:t.days_saturday,D:t.days_sunday,LMMcXVSD:t.days_daily};
for(const r of tr?.routes||[]){
const card=el('article','okhomes-nearby__bus');card.append(el('strong','',(r.code?r.code+' · ':'')+r.title.trim()));
card.append(el('p','',t.origin_label+': '+r.origin.trim()+' → '+t.destination_label+': '+r.destination.trim()));
if(r.departures?.length){
const times=r.departures,calendar=(days[r.days]||r.days)+' · '+(r.holidays==='Non festivos'?t.non_holidays:r.holidays==='Festivos'?t.holidays_only:t.all_days);
card.append(el('p','',calendar+' · '+t[r.direction]+': '+times.length+' '+t.departures_unit+' · '+t.between+' '+times[0]+' '+t.until+' '+times[times.length-1]));
card.append(el('p','',t.departures_label+': '+times.join(' · ')));
if(r.onDemand)card.append(el('p','okhomes-nearby__notes',t.demand));
}else card.append(el('p','',t.frequency_pending));
box.append(card);
}
if(!tr?.routes?.length)box.append(el('p','',t.frequency_pending));
if(tr?.source)box.append(link(t.schedule_link,tr.source,'okhomes-nearby__route'));
box.append(el('p','okhomes-nearby__notes',t.calendar_note));
box.append(link(t.planner_link,tr?.planner||'https://www.bus.gal/es','okhomes-nearby__route'));
const taxi=el('div','okhomes-nearby__taxi');taxi.append(el('h4','',t.taxi));
const tx=tr?.taxi;
taxi.append(el('p','',tx?.available?t.taxi_available:t.taxi_pending));
if(tx?.name)taxi.append(el('p','',tx.name));
if(tx?.phone)taxi.append(link(tx.phone.replace(/(\d{3})(\d{3})(\d{3})/,'$1 $2 $3'),'tel:+34'+tx.phone,'okhomes-nearby__route'));
if(tx?.source)taxi.append(link(t.taxi_source,tx.source,'okhomes-nearby__route'));
else{const url=new URL('https://www.google.com/maps/search/');url.searchParams.set('api','1');url.searchParams.set('query','taxi '+locality);taxi.append(link(t.taxi_search,url.href,'okhomes-nearby__route'));}
taxi.append(el('p','okhomes-nearby__notes',t.taxi_note));
box.append(taxi,el('p','okhomes-nearby__source',t.transport_date));content.append(box);
}
}
customElements.define('okhomes-nearby',Nearby);
})();
